import ReactGA from 'react-ga4';

// Initialize Google Analytics 4
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  
  if (!measurementId || measurementId === 'G-XXXXXXXXXX') {
    console.warn('GA4 Measurement ID not configured. Set REACT_APP_GA4_MEASUREMENT_ID in your .env file');
    return false;
  }

  ReactGA.initialize(measurementId, {
    debug: process.env.NODE_ENV === 'development',
    titleCase: false,
    gaOptions: {
      // Enable enhanced ecommerce for better user journey tracking
      send_page_view: false // We'll manually control page views
    }
  });

  console.log('Google Analytics 4 initialized with ID:', measurementId);
  return true;
};

// Track page views
export const trackPageView = (path, title = '') => {
  ReactGA.send({
    hitType: 'pageview',
    page: path,
    title: title || document.title
  });
};

// Track custom events
export const trackEvent = (action, category = 'User', label = '', value = 0) => {
  ReactGA.event({
    action,
    category,
    label,
    value
  });
};

// Track specific user actions for TherapistReviews
export const trackTherapistReviewsEvents = {
  // Search actions
  searchTherapist: (searchTerm, city = '') => {
    trackEvent('search_therapist', 'Search', `${searchTerm} in ${city}`.trim());
  },
  
  // Therapist profile views
  viewTherapistProfile: (therapistId, therapistName = '') => {
    trackEvent('view_therapist_profile', 'Engagement', `${therapistName} (ID: ${therapistId})`);
  },
  
  // Review actions
  startReview: (therapistId) => {
    trackEvent('start_review', 'Review', `Therapist ID: ${therapistId}`);
  },
  
  submitReview: (therapistId, overallRating) => {
    trackEvent('submit_review', 'Review', `Therapist ID: ${therapistId}`, overallRating);
  },
  
  // Authentication actions
  signUp: (method = 'email') => {
    trackEvent('sign_up', 'Authentication', method);
  },
  
  signIn: (method = 'email') => {
    trackEvent('sign_in', 'Authentication', method);
  },
  
  signOut: () => {
    trackEvent('sign_out', 'Authentication');
  },
  
  // Navigation
  clickExternalLink: (url, context = '') => {
    trackEvent('click_external_link', 'Navigation', `${url} from ${context}`);
  },
  
  // Error tracking
  errorOccurred: (errorType, errorMessage = '') => {
    trackEvent('error', 'Error', `${errorType}: ${errorMessage}`);
  }
};

// Track user session duration (call on app load/unload)
export const trackSessionStart = () => {
  trackEvent('session_start', 'Session');
  window.sessionStartTime = Date.now();
};

export const trackSessionEnd = () => {
  if (window.sessionStartTime) {
    const sessionDuration = Math.round((Date.now() - window.sessionStartTime) / 1000); // in seconds
    trackEvent('session_end', 'Session', 'Duration', sessionDuration);
  }
};